import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table"
import { Button } from "@/components/ui/button"
import { Plus, Trash2 } from "lucide-react"
import { type TestBill } from "@/types/config"
import { AddBillDialog } from "./add-bill-dialog"
import { useState } from "react"

interface TestBillsListProps {
  bills: TestBill[]
  onUpdate: (bills: TestBill[]) => void
  isLoading?: boolean
}

export function TestBillsList({ bills, onUpdate, isLoading }: TestBillsListProps) {
  const [dialogOpen, setDialogOpen] = useState(false)

  const removeBill = (index: number) => {
    const newBills = [...bills]
    newBills.splice(index, 1)
    onUpdate(newBills)
  }

  const addBill = (bill: TestBill) => {
    onUpdate([...bills, bill])
  }

  return (
    <div className="space-y-2">
      <div className="flex justify-between items-center">
        <h4 className="text-sm font-medium">Test Bills</h4>
        <Button
          variant="outline"
          size="sm"
          onClick={() => setDialogOpen(true)}
          disabled={isLoading}
        >
          <Plus className="h-4 w-4 mr-1" />
          Add Bill
        </Button>
      </div>
      
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Session Code</TableHead>
            <TableHead>Bill Number</TableHead>
            <TableHead className="w-16"><span className="sr-only">Actions</span></TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {bills.map((bill, index) => (
            <TableRow key={`${bill.SessionCode}-${bill.BillNumber}`}>
              <TableCell>{bill.SessionCode}</TableCell>
              <TableCell>{bill.BillNumber}</TableCell>
              <TableCell>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => removeBill(index)}
                  disabled={isLoading}
                >
                  <Trash2 className="h-4 w-4 text-red-500" />
                </Button>
              </TableCell>
            </TableRow>
          ))}
          {bills.length === 0 && (
            <TableRow>
              <TableCell colSpan={3} className="text-center text-muted-foreground">
                No test bills added
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      <AddBillDialog 
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        onAdd={addBill}
      />
    </div>
  )
}